export const modalComponent = {
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	},
	template: '<div ng-include="$ctrl.resolve.templateUrl"></div>',
	controller: class ModalComponent {
		constructor(ApiService) {
			'ngInject';

			this.apiService = ApiService;
		}

		$onInit() {
			if(!this.resolve.details) {
				this.resolve.details = {};
			}
			if(!this.resolve.details.bodyMessage) {
				this.resolve.details.bodyMessage = 'Are you sure you want to save the details?';
			}

			if(this.resolve.details.data) {
				let image = this.resolve.details.data.image;
				this.resolve.details.data.image = image !== '' ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
			}
		}
		
		buttonClick(button) {
			this.close();
			if(button.action) {
				button.action(this);
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/modal/modal.component.js